const COD_PAYMENT_METHOD_PREFIX = "pm_cod";

export const COD_PAYMENT_METHOD_TEST_IDS = {
    CONTAINER: `${COD_PAYMENT_METHOD_PREFIX}_container`,
    ICON: `${COD_PAYMENT_METHOD_PREFIX}_icon`,
    NAME: `${COD_PAYMENT_METHOD_PREFIX}_name`,
    TICK: `${COD_PAYMENT_METHOD_PREFIX}_tick`,
    DISABLE_MESSAGE: `${COD_PAYMENT_METHOD_PREFIX}_disable_msg`,
    PAY_BUTTON: `${COD_PAYMENT_METHOD_PREFIX}_pay_btn`,
};
